"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pimBackendUrl = exports.gatewayBackendUrl = exports.financeBackendUrl = exports.dbBackendUrl = exports.bosBackendUrl = exports.getGraphQlEndpoint = exports.getInfoEndpoint = exports.pimBackendHostName = exports.gatewayBackendHostName = exports.financeBackendHostName = exports.dbBackendHostName = exports.bosBackendHostName = void 0;
/**
 * Back-ends
 */
exports.bosBackendHostName = 'next-backend-bos';
exports.dbBackendHostName = 'next-backend-db';
exports.financeBackendHostName = 'next-backend-finance';
exports.gatewayBackendHostName = 'next-backend-gateway';
exports.pimBackendHostName = 'next-backend-pim';
const getInfoEndpoint = (hostname, port = 4000) => `http://${hostname}:${port}/api/info`;
exports.getInfoEndpoint = getInfoEndpoint;
const getGraphQlEndpoint = (hostname, port = 4000) => `http://${hostname}:${port}/graphql`;
exports.getGraphQlEndpoint = getGraphQlEndpoint;
exports.bosBackendUrl = (0, exports.getGraphQlEndpoint)(exports.bosBackendHostName);
exports.dbBackendUrl = (0, exports.getGraphQlEndpoint)(exports.dbBackendHostName);
exports.financeBackendUrl = (0, exports.getGraphQlEndpoint)(exports.financeBackendHostName);
exports.gatewayBackendUrl = (0, exports.getGraphQlEndpoint)(exports.gatewayBackendHostName);
exports.pimBackendUrl = (0, exports.getGraphQlEndpoint)(exports.pimBackendHostName);
//# sourceMappingURL=urls.js.map